module.exports = __webpack_public_path__ + "img/سارية-خطط-واجعل-رحلتك-أكثر-بساطة.bc42d7d2.png";